var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"align":"center"}},[_c('h1',[_vm._v("Page not found")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v(" Return home ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }